import { Injectable } from '@angular/core';
import { IDebounceConfig } from './i.debounce.config';

@Injectable()
export class DebounceConfig implements IDebounceConfig {
  readonly intervalInMilliseconds = 500;
}
